import React, { useEffect, createElement } from 'react';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export const PricingSection = () => {
  // Initialize Meta Pixel on component mount
  useEffect(() => {
    // Load Meta Pixel script
    ;
    (function (f: any, b: Document, e: string, v: string, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    // Initialize pixel with correct ID
    window.fbq('init', '3080182378851683');
  }, []);
  // Handle button click - track AddToCart event
  const handleCtaClick = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart');
    }
  };
  return <section id="pricing" className="py-10 md:py-16 px-6 md:px-10 bg-white" data-id="element-159">
      <div className="max-w-6xl mx-auto" data-id="element-160">
        <div className="text-center mb-8 md:mb-12" data-id="element-161">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-162">
            Comienza tu transformación financiera hoy
          </h2>
          <p className="text-xl text-gray-700 serif-text" data-id="element-163">
            Acceso inmediato al sistema completo
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-164">
          <div data-id="element-165">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/do8rG9asi4XhToN3tv4gpx/Generated_Image_November_20%2C_2025_-_6_28PM_%281%29.png" alt="¿Dónde se va mi dinero? disponible en todos tus dispositivos" className="w-full rounded-lg shadow-2xl" data-id="element-166" />
          </div>
          <div className="bg-cream p-8 rounded-xl shadow-lg" data-id="element-167">
            <div className="mb-8" data-id="element-168">
              <p className="text-gray-600 text-lg mb-2" data-id="element-169">Inversión única de:</p>
              <div className="flex items-baseline gap-2 mb-4" data-id="element-170">
                <span className="text-5xl md:text-6xl font-bold text-navy" data-id="element-171">
                  $9.97
                </span>
                <span className="text-xl text-gray-600" data-id="element-172">USD</span>
              </div>
              <p className="text-gold font-semibold text-lg" data-id="element-173">
                Menos que un almuerzo... pero cambia tu vida financiera para
                siempre
              </p>
            </div>
            <div className="mb-8 space-y-4" data-id="element-174">
              <h3 className="text-xl font-bold text-navy mb-4" data-id="element-175">Incluye:</h3>
              <div className="space-y-3" data-id="element-176">
                <div className="flex items-start" data-id="element-177">
                  <span className="text-gold font-bold mr-2 text-xl" data-id="element-178">✓</span>
                  <span className="text-gray-700" data-id="element-179">
                    Acceso inmediato al sistema completo
                  </span>
                </div>
                <div className="flex items-start" data-id="element-180">
                  <span className="text-gold font-bold mr-2 text-xl" data-id="element-181">✓</span>
                  <span className="text-gray-700" data-id="element-182">
                    Todos los métodos y estrategias
                  </span>
                </div>
                <div className="flex items-start" data-id="element-183">
                  <span className="text-gold font-bold mr-2 text-xl" data-id="element-184">✓</span>
                  <span className="text-gray-700" data-id="element-185">
                    PDFs descargables para imprimir
                  </span>
                </div>
                <div className="flex items-start" data-id="element-186">
                  <span className="text-gold font-bold mr-2 text-xl" data-id="element-187">✓</span>
                  <span className="text-gray-700" data-id="element-188">
                    Funciona en celular, tablet y computadora
                  </span>
                </div>
                <div className="flex items-start" data-id="element-189">
                  <span className="text-gold font-bold mr-2 text-xl" data-id="element-190">✓</span>
                  <span className="text-gray-700" data-id="element-191">Acceso de por vida</span>
                </div>
              </div>
            </div>
            <a href="https://www.voicesoffreedomus.com/cart/45436913189050:1" className="block w-full btn-primary text-xl py-4 mb-4 text-center no-underline" target="_blank" rel="noopener noreferrer" onClick={handleCtaClick} data-id="element-192">
              Sí, Quiero Transformar Mi Vida Financiera
            </a>
            <p className="text-center text-sm text-gray-600" data-id="element-193">
              🔒 Pago seguro y protegido
            </p>
          </div>
        </div>

        {/* Meta Pixel noscript fallback */}
        <noscript data-id="element-194">
          <img height="1" width="1" style={{
          display: 'none'
        }} src="https://www.facebook.com/tr?id=3080182378851683&ev=PageView&noscript=1" alt="" data-id="element-195" />
        </noscript>

        <div className="mt-8 bg-gradient-to-br from-navy to-lightBlue p-8 md:p-12 rounded-2xl shadow-2xl" data-id="element-196">
          <div className="text-center mb-8" data-id="element-197">
            <div className="inline-block bg-gold text-navy px-6 py-2 rounded-full font-bold text-lg mb-4" data-id="element-198">
              🎁 BONO GRATIS INCLUIDO
            </div>
            <h3 className="text-3xl md:text-4xl font-bold text-cream mb-2" data-id="element-199">
              La Guía del Dinero Tranquilo™
            </h3>
            <p className="text-gold text-xl font-semibold" data-id="element-200">
              Regalo exclusivo con tu compra
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-201">
            <div className="order-2 md:order-1" data-id="element-202">
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl text-cream" data-id="element-203">
                <p className="text-lg mb-6 leading-relaxed" data-id="element-204">
                  Un mini-PDF de 7 minutos para usar cuando la ansiedad
                  financiera sube. Incluye respiraciones, frases y recordatorios
                  que te devuelven calma antes de tomar decisiones importantes.
                </p>
                <div className="space-y-3" data-id="element-205">
                  <div className="flex items-start" data-id="element-206">
                    <span className="text-gold font-bold mr-2 text-xl" data-id="element-207">✓</span>
                    <span data-id="element-208">Técnicas de respiración para calmar la ansiedad</span>
                  </div>
                  <div className="flex items-start" data-id="element-209">
                    <span className="text-gold font-bold mr-2 text-xl" data-id="element-210">✓</span>
                    <span data-id="element-211">Frases poderosas para recuperar claridad</span>
                  </div>
                  <div className="flex items-start" data-id="element-212">
                    <span className="text-gold font-bold mr-2 text-xl" data-id="element-213">✓</span>
                    <span data-id="element-214">
                      Recordatorios para momentos de estrés financiero
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-215">
                    <span className="text-gold font-bold mr-2 text-xl" data-id="element-216">✓</span>
                    <span data-id="element-217">
                      Perfecto para tomar mejores decisiones con dinero
                    </span>
                  </div>
                </div>
                <p className="mt-6 text-gold font-semibold text-lg" data-id="element-218">
                  Solo 7 minutos que te devolverán la paz mental
                </p>
              </div>
            </div>
            <div className="order-1 md:order-2" data-id="element-219">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dBJtNboVyfgs5UY8U8xrVM/Generated_Image_November_20%2C_2025_-_6_34PM.png" alt="La Guía del Dinero Tranquilo - Bono gratis" className="w-full max-w-sm mx-auto rounded-lg shadow-2xl" data-id="element-220" />
            </div>
          </div>
        </div>
        <div className="mt-12 text-center max-w-3xl mx-auto" data-id="element-221">
          <p className="text-lg text-gray-700 serif-text" data-id="element-222">
            No es solo una guía. Es tu primera inversión real en ti misma. Es el
            momento de pasar de sobrevivir a vivir con tranquilidad.
          </p>
        </div>
      </div>
    </section>;
};